import { render } from "./PhoneFooter.vue?vue&type=template&id=aacaa1b6&scoped=true"
import script from "./PhoneFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneFooter.vue?vue&type=script&setup=true&lang=js"

import "./PhoneFooter.vue?vue&type=style&index=0&id=aacaa1b6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aacaa1b6"],['__file',"src/pages/components/parts/PhoneFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aacaa1b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aacaa1b6', __exports__)) {
    console.log('reload')
    api.reload('aacaa1b6', __exports__)
  }
  
  module.hot.accept("./PhoneFooter.vue?vue&type=template&id=aacaa1b6&scoped=true", () => {
    console.log('re-render')
    api.rerender('aacaa1b6', render)
  })

}


export default __exports__